import * as constants from './settings-types';

export default {
  [constants.SET_DEVICE_TOKENS] (state, tokens) {
    state.device_tokens = tokens;
  },
  [constants.SET_SETTINGS_KEY] (state, key) {
    state.settings_key = key;
  },
  [constants.SET_ALL_PERMISSIONS] (state, permission) {
    state.permission = Object.assign({}, permission);
  },
  [constants.INCREASE_PER_PAGE] (state) {
    state.rowsPerPage += 50
  },
  [constants.RESET_PER_PAGE] (state) {
    state.rowsPerPage = 50
  },
  [constants.SET_LAYOUT_SETTINGS] (state, { value, page }) {
    if (!state.layoutSettings.some((layout) => layout.page === value.page)) {
      state.layoutSettings.push(value);
      return;
    }

    state.layoutSettings = state.layoutSettings.map(item => {
      if (item.page === value.page) {
        return { ...value, isFetched: true };
      }

      return item;
    });
  },
  [constants.SET_USER_NOTIFICATION_SETTINGS] (state, value) {
    state.userNotificationsSettings = value || { email: false, property_true_owner_change: false };
  },
  [constants.SET_USER_OPEX_DISPLAY] (state, value) {
    state.opexDisplay = value;
  },
  [constants.SET_FOCUS_AREA_KEY] (state, value) {
    state.focus_area_key = value;
  },
  [constants.SET_FOCUS_AREA] (state, value) {
    state.focus_area = value || null;
  },
  [constants.SET_USER_VISUALIZATION_SETTINGS] (state, value) {
    state.visualizationSettings = value || null;
  },
  [constants.SET_RECORD_PERMISSIONS] (state, value) {
    state.recordPermissions = value || [];
  },
  [constants.SET_CUSTOM_FIELDS] (state, customField) {
    state.custom_fields = { ...state.custom_fields, ...customField };
  },
  [constants.SET_AI_KEYS] (state, value) {
    state.aiKeys = value || [];
  },
}
